import axios from 'axios';
export class ModifyStreamCommand {
    async execute(privateKey, platform, backgroundImage, afreecaId, twitchId) {
        const url = `https://mycast.xyz:9011/user/${privateKey}/stream`;
        try {
            const form = {
                platform,
                backgroundImage,
                afreecaId,
                twitchId,
            };
            const { data } = await axios.put(url, form);
            return data.result;
        }
        catch (_a) {
            return false;
        }
    }
}
